import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {

  appName: string;

  constructor(
    private router: Router,
    private browserTitle: Title,
    private activatedRoute: ActivatedRoute
  ) {
    this.appName = 'PIAS';
  }

  ngOnInit(): void {
    // Setting dynamic page title
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          const child: ActivatedRoute | null = this.activatedRoute.firstChild;
          let title = child && child.snapshot.data['title'];
          if (title) {
            return title;
          }
        })
      )
      .subscribe((title) => {
        if (title) {
          this.browserTitle.setTitle(`${title} | ${this.appName}`)
        }
      });
  }

}
